module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( name ))==null?'':__t)+
'</td>\r\n';
 if (typeof organizationId == "undefined" || organizationId == '') { 
__p+='\r\n<td></td>\r\n';
 } else { 
__p+='\r\n<td><a href = "/#organization/'+
((__t=( organizationId ))==null?'':__t)+
'">'+
((__t=( organization ))==null?'':__t)+
'</a></td>\r\n';
 } 
__p+='\r\n<td>'+
((__t=( object.signsLimit ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( object.signX ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( object.signY ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( object.signWidth ))==null?'':__t)+
'</td>\r\n<td><span class="glyphicon glyphicon-edit clickable" id="edit" rel-id=""/></td>\r\n<td><span class="glyphicon glyphicon-remove clickable" id="delete" rel-id=""/></td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/document-types/document-types-row.html
// module id = 457
// module chunks = 0